<div class="wrapper">
    <header>
        <h2>{{ data?.title }}</h2>
        <button 
            mat-icon-button 
            aria-label="Close" 
            class="close-button mat-icon-button"
            (click)="cancel()"
        >
            <span class="icon-close"></span>
        </button>
    </header>
    <mat-dialog-content>
        <span [innerHTML]="data?.body"></span>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button class="bciti-inline-button" [disabled]="loading" (click)="cancel()">
            {{ data?.cancelLabel }}
        </button>
        <button [ngClass]="typeClass" [disabled]="loading" (click)="confirm()">
            <span *ngIf="!loading">{{ data?.confirmLabel }}</span>
            <span *ngIf="loading" class="loading-spinner">
                <mat-progress-spinner 
                    mode="indeterminate" 
                    diameter="20"
                ></mat-progress-spinner>
            </span>
        </button>
    </mat-dialog-actions>
</div>
